import React, { useState } from "react";
import ChatWidget from "./ChatWidget"; // adjust path if ChatWidget lives elsewhere

const FloatingChatbot = () => {
  const [open, setOpen] = useState(false);

  return (
    <div className="fixed bottom-5 right-5 z-50">
      {open && (
        <div className="mb-3 w-[360px] h-[500px] shadow-2xl rounded-2xl overflow-hidden border border-gray-200 dark:border-gray-700 bg-white dark:bg-zinc-900">
          <ChatWidget />
        </div>
      )}

      <button
        onClick={() => setOpen(!open)}
        className="w-14 h-14 rounded-full bg-sky-600 hover:bg-sky-700 text-white flex items-center justify-center shadow-lg"
        title={open ? "Close chatbot" : "Open TeamCoin chatbot"}
      >
        {open ? "✕" : "💬"}
      </button>
    </div>
  );
};

export default FloatingChatbot;
